import { render, staticRenderFns } from "./TabsAdvPreview.vue?vue&type=template&id=47326363&scoped=true"
import script from "./TabsAdvPreview.vue?vue&type=script&lang=js"
export * from "./TabsAdvPreview.vue?vue&type=script&lang=js"
import style0 from "./TabsAdvPreview.vue?vue&type=style&index=0&id=47326363&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47326363",
  null
  
)

export default component.exports